import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import './myappointment.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Required for default styling
import { AppointmentListingHeader, CreateAppointmentButton,AppointmentCancellationModal, ReportCard, AppointmentCard,RescheduleModal } from "tutorapp-components";
import { fetchAppointments, resetUpcomingAppointments } from "../redux/actions/appointmentActions";
import { useDispatch, useSelector } from "react-redux";
import { fetchUpcomingSessions, resetUpcomingSessions } from "../redux/actions/upcomingSessionActions";
import { apiService } from "../utils/apiRequest";
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../redux/actions/authActions";
import CircularProgress from '@mui/material/CircularProgress';
import { resetSessionData, setShowReportButton } from "../redux/actions/sessionActions";
import InfiniteScroll from 'react-infinite-scroll-component';
import { Modal, Button } from "react-bootstrap";
import { setUserPreferences } from "../redux/actions/userPreferencesActions";
import { resetFamilyAppointmentState } from "../redux/actions/familyAppointmentActions";
import { resetSchoolAppointmentState } from "../redux/actions/schoolAppointmentActions";
import { resetFamilyPresetValues, setAppointmentType } from "../redux/actions/familyPresetValuesActions";
import { setsessionid } from "../redux/actions/sessionActions";
import { resetSchoolSessions } from "../redux/actions/schoolsessionActions";


export default function MyAppointment() {

  const moment = require('moment-timezone');

  const [overlayVisible, setOverlayVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [rescheduleModalVisible, setRescheduleModalVisible] = useState(false);
  const [appointmentId, setAppointmentId] = useState();
  const [sessionType, setSessionType] = useState();
  const [userName, setUserName] = useState();
  const [loading, setLoading] = useState(false);
  const [sessionstatus, setSessionstatus] = useState('')
  const [appointmentModaldData, setAppointmentModalData] = useState(false);
  const [showSwitch, setShowSwitch] = useState(false); // controls whether to show the div


  // Infinite scroll state for upcoming sessions
  const [sessionsPage, setSessionsPage] = useState(1);
  const [hasMoreSessions, setHasMoreSessions] = useState(true);
  const [sessionsList, setSessionsList] = useState([]);
  const [isInitialSessionsFetch, setIsInitialSessionsFetch] = useState(true);

  // Infinite scroll state for appointments
  const [appointmentsPage, setAppointmentsPage] = useState(1);
  const [hasMoreAppointments, setHasMoreAppointments] = useState(true);
  const [appointmentsList, setAppointmentsList] = useState([]);
  const [isInitialAppointmentsFetch, setIsInitialAppointmentsFetch] = useState(true);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const dispatch = useDispatch();
  const sessions = useSelector((state) => state.session.sessions);
  const buildVersion = process.env.REACT_APP_BUILD_VERSION ?? null;
  const navigate = useNavigate();

  const imagePaths = {
    calender: './images/ic_calender.svg',
    time: './images/ic_time.svg',
    down: './images/ic_down.svg',
  };

  const dummyAppointmentImages = {
    view: "./images/view.svg",
    add: "https://via.placeholder.com/25",
    cancel: "https://via.placeholder.com/25",
  };


  useEffect(() => {
    dispatch(resetSessionData());
    dispatch(resetUpcomingSessions());
    dispatch(resetUpcomingAppointments())
    dispatch(resetFamilyAppointmentState())
    dispatch(resetSchoolAppointmentState())
    dispatch((resetFamilyPresetValues()))
    dispatch((resetSchoolAppointmentState()))
    dispatch(resetSchoolSessions())

  }, []);

  const { appointments, error, appointmentloading } = useSelector((state) => state.appointments);
  const { upcomingSessions, sessionloading } = useSelector((state) => state.upcomingSessions);
  const selectedFranchise = useSelector((state) => state.franchise?.selectedFranchise);
  const userData = useSelector((state) => state.auth.userData);
  const userPreferences = useSelector((state) => state.userPreferences);
  const showschool = selectedFranchise.country == 'UK'






  function extractTime(datetimeString) {
    let match = datetimeString.match(/\d{4}-\d{2}-\d{2} (\d{2}):(\d{2}):(\d{2})/);

    if (match) {
      return `${match[1]}:${match[2]}:${match[3]}`;
    }

    return null; // Return null if no time found
  }

  const convertTimeFormat = (timeString, targetTimezone) => {
    if (!timeString) return '';

    // Validate timeString format (HH:MM:SS)
    const match = timeString.match(/^(\d{2}:\d{2}:\d{2})$/);
    if (!match) return timeString; // Return original string if format doesn't match

    // Parse the time string as UTC and convert to target timezone
    const utcTime = moment.utc(timeString, 'HH:mm:ss');
    if (!moment.tz.zone(targetTimezone)) return timeString; // Return original if invalid timezone

    const convertedTime = utcTime.tz(targetTimezone).format('HH:mm');

    return convertedTime; 
  };


  const parseDateString = (dateStr) => {
    if (!dateStr) return null;

    // Extract components from the fixed format "YYYY-MM-DD HH:MM:SS"
    const [datePart, timePart] = dateStr.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);

    // Create a UTC date object (month is 0-based in JavaScript Date)
    return new Date(Date.UTC(year, month - 1, day, hour, minute, second));
  };


  // Fetch more appointments for infinite scroll
  const fetchMoreAppointments = () => {
    dispatch(fetchAppointments(selectedFranchise, appointmentsPage))
      .then((response) => {
      }).catch((error) => {
        console.error("Error in fetchMoreAppointments:", error);
        setHasMoreAppointments(false);
      });
  };

  useEffect(() => {
    if (appointments?.userPreferences || upcomingSessions?.userPreferences) {
      const prefs = appointments.userPreferences || upcomingSessions?.userPreferences;
      const {
        timezone = 'UTC',
        dateformat = 'MM/DD/YYYY',
        timeformat = 'hh:mm A'
      } = prefs;

      dispatch(setUserPreferences({ timezone, dateformat, timeformat }));
    }
  }, [appointments, upcomingSessions, dispatch]);



  // Fetch more sessions for infinite scroll
  const fetchMoreSessions = () => {
    dispatch(fetchUpcomingSessions(selectedFranchise, sessionsPage, sessionstatus));
    const nextPage = sessionsPage + 1;

    setSessionsPage(nextPage);
    setHasMoreSessions(true);
  };

  // Sync appointmentsList with appointments.appointments
  useEffect(() => {
    if (appointments.status === "success" && appointments.appointments?.length > 0) {
      const newAppointments = appointments.appointments || [];
      setAppointmentsList((prev) => {
        const existingIds = new Set(prev.map((appt) => appt.appointment_id));
        const filteredNewAppointments = newAppointments.filter((appt) => !existingIds.has(appt.appointment_id));
        return [...prev, ...filteredNewAppointments];
      });
      if (newAppointments.length < 5 || newAppointments.length === 0) {
        setHasMoreAppointments(false);
      }
      if (isInitialAppointmentsFetch) {
        setIsInitialAppointmentsFetch(false);
      }
    }
  }, [appointments.appointments]);

  // Sync sessionsList with upcomingSessions.sessions
  useEffect(() => {
    if (upcomingSessions.sessions && upcomingSessions.sessions.length > 0) {
      const newSessions = upcomingSessions.sessions || [];
      setSessionsList((prev) => {
        const existingIds = new Set(prev.map((session) => session.appointment_id));
        const filteredNewSessions = newSessions.filter((session) => !existingIds.has(session.appointment_id));
        return [...prev, ...filteredNewSessions];
      });

      if (isInitialSessionsFetch) {
        setIsInitialSessionsFetch(false);
      }
    }


  }, [upcomingSessions.sessions]);


  useEffect(() => {
    setUserName(userData.first_name + ' ' + userData.last_name);
    setAppointmentsList([]);
    setSessionsList([]);
    setAppointmentsPage(1);
    setSessionsPage(1);
    setHasMoreAppointments(true);
    setHasMoreSessions(true);
    setIsInitialAppointmentsFetch(true);
    setIsInitialSessionsFetch(true);
    fetchMoreAppointments();
    fetchMoreSessions();
  }, [selectedFranchise, dispatch]);


  //for fomatting date to date and month
  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  //for fromatting time in appointmentcard
  const formatTime = (time) => {
    return time ? `${time}:00` : "";
  };


  //To cancel appointment for school and family
  const handleConfirm = (action) => {

    cancelAppointment(appointmentId.appointment_id, action);
    setModalVisible(false)
  };

  const handleView = (data) => {


    dispatch(setsessionid(data.appointment_id))
    dispatch(setUserPreferences(upcomingSessions?.userPreferences))
    dispatch(setShowReportButton(data.status))
    navigate("/sessiondetails");
  };


  const handleAppointmentView = (data) => {

    dispatch(setsessionid(data))
    dispatch(setUserPreferences(appointments?.userPreferences))
    navigate("/editappointment", { state: { appointment_id: data.appointment_id } });
  };




  //To reschedule appointments
  const handleReschedule = (appointmentid, sessiontype) => {
    setAppointmentId(appointmentid);
    setSessionType(sessiontype);
    setRescheduleModalVisible(true);
  };

  //for calling functions to cancel appointment
  const handleCancel = (appointment) => {
    setSessionsPage(1);

    setAppointmentId(appointment);
    if (appointment.appointment_for === 'Families' || appointment.session_for === 'Families') {

      setAppointmentModalData(true)
      setAppointmentId(appointment)
      setModalVisible(true);
    } else {
      setAppointmentModalData(false)
      setModalVisible(true);
    }
  };

  const cancelAppointment = async (appointmentId, action) => {
    try {
      setLoading(true);
      const cancelappointment = process.env.REACT_APP_API_URL + 'getCancelAppointment';
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ appointment_id: appointmentId, action }),
      };
      const response = await apiService(cancelappointment, options);
      if (response.status == 'success') {

        setAppointmentsList([]);
        setSessionsList([]);
        setAppointmentsPage(1);
        setHasMoreAppointments(true);
        setHasMoreSessions(true);
        fetchMoreAppointments();
        setSessionsPage(1)
        fetchMoreSessions();
        setModalVisible(false);
        setLoading(false);
        setShow(false)
        toast.success(response.message, { // Test with static message
          position: "top-center",
          autoClose: 4000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: { backgroundColor: "#388E3C", color: "#fff", fontWeight: "500" }
        });


      } else {
        console.error("Failed to cancel appointment:", response.message);
        setModalVisible(false);
        setShow(false)


        toast.error(response.message,

          {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true, // Hides the bottom timer line
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "dark",
            style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" } // Custom Red Background
          }


        );
      }
    } catch (error) {
      console.error("Error while cancelling appointment:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleclose = () => {
    setRescheduleModalVisible(false);
  };

  function handleSaveChanges(appointmentModalData) {
    const action = 'cancel';
    cancelAppointment(appointmentModalData?.appointment_id, action); // Call cancelAppointment with proper arguments
    setShow(false)

  }
  //for selecting data from upcoming session for session creation 
  const onSavehandle = (date, startTime, duration, endTime) => {
    const formattedData = {
      updated_appointment: {
        appointment_date: formatDate(date),
        start_time: formatTime(startTime),
        end_time: formatTime(endTime),
        session_type: sessionType,
      },
    };
    AppointmentReschedule(appointmentId.appointment_id, formattedData.updated_appointment);
  };



  //reschedule api calling
  const AppointmentReschedule = async (appointmentId, updatedAppointment) => {
    try {
      setLoading(true);
      const rescheduleappointment = process.env.REACT_APP_API_URL + 'rescheduleAppointment';
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ appointment_id: appointmentId, updated_appointment: updatedAppointment }),
      };
      const response = await apiService(rescheduleappointment, options);
      if (response.status == 'success') {
        setAppointmentsList([]);
        setSessionsList([]);
        setAppointmentsPage(1);
        setSessionsPage(1);
        setHasMoreAppointments(true);
        setHasMoreSessions(true);
        fetchMoreAppointments();
        fetchMoreSessions();
        setRescheduleModalVisible(false);
        setLoading(false)
        toast.success(response.message, {
          position: "top-center",
          autoClose: 4000,
          hideProgressBar: true, // Hides the bottom timer line
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: { backgroundColor: "#388E3C", color: "#fff", fontWeight: "500" } // Custom Green Background
        });
      } else {
        console.error("Failed to reschedule appointment:", response.message);
        setRescheduleModalVisible(false)
        toast.error(response.message,

          {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true, // Hides the bottom timer line
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "dark",
            style: { backgroundColor: "#D32F2F", color: "#fff", fontWeight: "500" } // Custom Red Background
          }


        );
      }
    } catch (error) {
      console.error("Error while rescheduling appointment:", error);
    } finally {
      setLoading(false);
    }
  };

  //to hide/show sidemenu bar
  const handleShowMenu = () => {
    setOverlayVisible(!overlayVisible);
  };

  //For user logout
  const handleLogout = () => {
    dispatch(logoutUser());
  };

  useEffect(() => {
    const checkSwitchPreference = async () => {
      try {
        const displaySwitchUrl = process.env.REACT_APP_API_URL + 'getTutorChoice?tutor_id=' + selectedFranchise.tutor_id + '&franchise_id=' + selectedFranchise.franchise_id;
        const options = {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        };
        const response = await apiService(displaySwitchUrl, options);
        console.log("Switch preference response:", response);
        if (response.status == 'success' && response.tutor_choice == '1') {
          setShowSwitch(true);
        } else {
          setShowSwitch(false);
        }
      } catch (error) {
        console.error("Error while fetching switch preference:", error);
        setShowSwitch(false);
      }
    };
    checkSwitchPreference();
  }, [selectedFranchise]);

  const confirmSwitchToOldView = () => {
    if (window.confirm("Are you sure you want to switch to the old view?")) {
      handleSwitchToOldView();
    }
  };

  const handleSwitchToOldView = async () => {
    try {
      const switchUrl = process.env.REACT_APP_API_URL + 'switchTutorChoice';
      const options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tutor_id: selectedFranchise.tutor_id, franchise_id: selectedFranchise.franchise_id }),
      };
      const response = await apiService(switchUrl, options);
      if (response.status == 'success') {
        window.location.href = `${process.env.REACT_APP_SUITECRM_BASE_URL}/index.php?module=tm_TutorMatching&action=JobBoard`;
      } else {
        console.error("Failed to switch to old view:", response.message);
      }
    } catch (error) {
      console.error("Error while switching to old view:", error);
    }
  };

  const icons = {
    view: "./images/view.svg",
    reschedule: "./images/Add.svg",
    cancel: "./images/Cancel.svg",
    optionsmenu: "./images/ic_options.svg",
    warning: "./images/warning.png",
    close: "./images/ic_close2.svg"

  };

  //To pass data from session card to sessiondetails 
  const handleCreatReport = (data) => {

    dispatch(setsessionid(data.appointment_id))
    dispatch(setUserPreferences(upcomingSessions?.userPreferences))
    dispatch(setShowReportButton(data.status))
    navigate("/sessiondetails");
    navigate("/sessiondetails");

  };


  // Function to calculate duration in minutes
  const calculateDuration = (startDateTime, endDateTime) => {
    if (!startDateTime || !endDateTime) return 0;

    // Parse start and end times using moment
    const start = moment(startDateTime, 'YYYY-MM-DD HH:mm:ss');
    const end = moment(endDateTime, 'YYYY-MM-DD HH:mm:ss');

    // Calculate duration in minutes
    return end.diff(start, 'minutes');
  };

  const handleCreateClick = () => {

    if (!showschool) {
      dispatch(setAppointmentType({ appointment_type: 0 }));
      navigate("/filldetails");
    } else {
      navigate("/SelectAppointmentType");
    }
  };


  useEffect(() => {
    if (upcomingSessions?.status === 'fail' || upcomingSessions?.sessions?.length < 25) {
      setHasMoreSessions(false);
    }
  }, [upcomingSessions]);


  const handlereportarrowclick = () => {

    dispatch(resetUpcomingSessions())
    navigate("/reportlisting")
  }



  if (appointmentloading && sessionloading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress style={{ color: "black" }} />
      </div>
    );
  }


  return (
    <>
      <ToastContainer style={{ zIndex: 99999 }} testID="my-appointment"/>
      <div className="appointment-container">
        <div className="sticky-header bg-white shadow-sm" style={{ zIndex: 90 }}>
          <AppointmentListingHeader headerImagePath={{ logo: "./images/ic_logo_white.png", gridIcon: "./images/ic_menu.svg" }} showmenu={handleShowMenu} />
        </div>

        {/* Overlay Sidebar */}
        {overlayVisible && (
          <div
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              width: "100vw",
              height: `calc(100dvh + env(safe-area-inset-bottom))`,
              backgroundColor: "rgba(0,0,0,0.5)",
              zIndex: 99,
              fontFamily: 'GT-Walsheim'
            }}
            onClick={() => setOverlayVisible(false)}
          >
            <div onClick={(e) => e.stopPropagation()}>
              <Sidebar
                collapsed={false}
                toggled={overlayVisible}
                width={270}
                backgroundColor="black"
                transitionDuration={100}
                rootStyles={{
                  position: "fixed",
                  top: 0,
                  right: 0,
                  height: `calc(100dvh - env(safe-area-inset-bottom))`,
                  color: "white",
                  zIndex: 1001,
                  backgroundColor: "black",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  fontFamily: 'GT-Walsheim'
                }}
              >
                <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
                  <div className="menu-heading">
                    <div style={{ fontFamily: 'GT-Walsheim' }} > Menu   </div>
                    <div onClick={() => setOverlayVisible(false)}> <img src="./images/ic_close.svg" alt="Job Board" style={{ width: 24, height: 24, marginRight: 8 }} />   </div>


                  </div>
                  <Menu closeOnClick>
                    <SubMenu
                      label={
                        <span style={{ display: 'flex', alignItems: 'center', fontsize: '10px' }}>
                          <img
                            src="./images/sessionmenu.svg"
                            alt="Job Board"
                            style={{ width: 22, height: 22, marginRight: 10 }}
                          />
                          Sessions
                        </span>
                      }
                      style={{ backgroundColor: "black", color: "white" }}
                    >
                      <MenuItem style={{ backgroundColor: "black", color: "white" }} onClick={handleCreateClick}>
                        Create Appointment
                      </MenuItem>
                      <MenuItem style={{ backgroundColor: "black", color: "white" }} onClick={() => navigate("/upcomingappointments")}>
                        View Appointments
                      </MenuItem>
                      <MenuItem style={{ backgroundColor: "black", color: "white" }} onClick={handlereportarrowclick}>
                        Session Reports
                      </MenuItem>
                    </SubMenu>
                  </Menu>
                  {showSwitch && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "13%",
                      padding: "10px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                      gap: "5px",
                      width: "100%",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <span style={{ fontSize: "14px", color: "#fff" }} onClick={confirmSwitchToOldView}>Switch to the old view</span>
                        <span style={{ marginLeft: "18px" }} onClick={confirmSwitchToOldView}>
                          <img style={{ width: "18px"}} src="./images/refresh.svg" alt="Old View" />
                        </span>
                      </div>
                    </div>

                  </div>
                  )}
                  <div
                    style={{
                      position: "absolute",
                      bottom: "4%",
                      padding: "10px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      textAlign: "center",
                      gap: "5px",
                      width: "100%",
                      paddingBottom: `calc(10px + env(safe-area-inset-bottom))`,
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          minWidth: "40px", // Prevent compression
                          minHeight: "40px", // Prevent compression
                          aspectRatio: "1 / 1", // Enforce 1:1 aspect ratio
                          borderRadius: "50%",
                          backgroundColor: "#F5F7FA",
                          color: "gray",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "bold",
                          fontSize: "14px",
                          textTransform: "uppercase",
                          flexShrink: 0, // Prevent flexbox shrinkage
                        }}
                      >
                        {userName.split(" ").map((word) => word[0]).slice(0, 2).join("")}
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                        <span style={{ fontSize: "14px", color: "#fff" }}>{userName}</span>
                        <span onClick={handleLogout}>
                          <img src="./images/profile.svg" alt="Profile" />
                        </span>
                      </div>
                    </div>

                  </div>
                </div>
              </Sidebar>
            </div>
          </div>
        )}

        <div className="appointment-main">
          <div>
            <div className="upper-text mt-4 mb-1" style={{ fontFamily: 'GT-Walsheim-Bold', fontWeight: 800 }}>MY APPOINTMENTS</div>
            <div className="sub-header mt-3  mb-2 d-flex justify-content-between align-items-center">
              <span style={{ fontFamily: 'GT-Walsheim-Bold' }}>UPCOMING</span>
              <span onClick={() => navigate("/upcomingappointments")}>
                <img src="./images/ic_right_end.svg" alt="icon" style={{ width: '29px', height: '29px' }} />
              </span>
            </div>

            <div className="d-flex justify-content-center">
              <div className="d-flex overflow-auto py-1 px-1 gap-4 custom-scrollbar" style={{ whiteSpace: "nowrap", maxWidth: "100%" }}>
                {appointmentsList.length > 0 ? (
                  appointmentsList.map((appointment) => (
                    <div key={appointment.appointment_id} className="flex-shrink-0">
                      <AppointmentCard
                        appointmentdetails={appointment}
                        appointmentimagePaths={dummyAppointmentImages}
                        onViewPress={handleAppointmentView}
                        onReschedulePress={handleReschedule}
                        onCancelPress={handleCancel}
                        icons={icons}
                        userPreferences={userPreferences}

                      />
                    </div>
                  ))
                ) : (
                  <div
                    className="d-flex overflow-auto flex-wrap py-2 px-3 gap-3 align-items-center w-80 custom-scrollbar text-secondary"
                    style={{
                      fontSize: "1rem",
                      fontWeight: "500",
                      letterSpacing: "0.5px",
                      maxWidth: "100%",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      whiteSpace: "normal",
                      fontFamily: 'GT-Walsheim'
                    }}
                  >
                    {appointments.message}
                  </div>
                )}

              </div>
            </div>
            {/* </InfiniteScroll> */}
          </div>

          <div className="d-flex justify-content-center mt-3 mb-2">
            <CreateAppointmentButton handleCreateAppointment={handleCreateClick} />
          </div>


          <div className="sub-header mb-3 mt-4 d-flex justify-content-between align-items-center">
            <span style={{ fontFamily: 'GT-Walsheim-Bold' }}>REPORTS</span>
            <span onClick={handlereportarrowclick}>
              <img src="./images/ic_right_end.svg" alt="icon" style={{ width: '29px', height: '29px' }} />
            </span>
          </div>

          <div>
            <InfiniteScroll
              dataLength={sessionsList.length}
              next={fetchMoreSessions}
              hasMore={hasMoreSessions}
              loader={<div className="text-center my-3"><CircularProgress size={30} style={{ color: "black" }} /></div>}
              endMessage={
                <div
                  className="text-center text-secondary"
                  style={{ fontFamily: 'GT-Walsheim', margin: 0, paddingBottom: 0 }}
                >
                  No more reports to load.
                </div>
              }
              style={{ overflow: 'visible', fontFamily: 'GT-Walsheim' }}
            >
              <div className="row custom-row-gap justify-content-center">
                {sessionsList.map((report, index) => (
                  <div key={index} className="col-12 col-sm-6 col-md-6 d-flex justify-content-center">
                    <ReportCard
                      item={report}
                      onViewPress={handleView}
                      onReschedulePress={handleCreatReport}
                      onCancelPress={handleCancel}
                      icons={icons}
                      onReportPress={handleCreatReport}
                      userPreferences={userPreferences}
                    />
                  </div>
                ))}
              </div>
            </InfiniteScroll>
          </div>

          <AppointmentCancellationModal
            appointmentfor ={appointmentModaldData}
            visible={modalVisible}
            onClose={() => setModalVisible(false)}
            onConfirm={handleConfirm}
          />
          {appointmentId && appointmentId.start_date_time && (
            <RescheduleModal
              defaultdate={parseDateString(appointmentId.start_date_time)}
              defaultStartTime={convertTimeFormat(extractTime(appointmentId.start_date_time), userPreferences?.timezone)}
              defaultEndTime={convertTimeFormat(extractTime(appointmentId.end_date_time), userPreferences?.timezone)} // Ensure end_date_time exists
              duration={calculateDuration(appointmentId.start_date_time, appointmentId.end_date_time)}
              userPreferences={userPreferences}
              imagePaths={imagePaths}
              onClose={handleclose}
              visible={rescheduleModalVisible}
              onSave={onSavehandle}
            />
          )}
        </div>


      <Modal show={show} onHide={handleClose} testID="cancel-appointment-modal">
  <Modal.Header closeButton testID="modal-header">
  </Modal.Header>
  <Modal.Body style={{ fontFamily: 'GT-Walsheim' }} testID="modal-body">
    Are you sure you want to cancel appointment?
  </Modal.Body>
  <Modal.Footer style={{ fontFamily: 'GT-Walsheim' }} testID="modal-footer">
    <Button variant="secondary" onClick={handleClose} testID="no-button">
      No
    </Button>
    <Button
      variant="primary"
      onClick={() => handleSaveChanges(appointmentModaldData)}
      testID="yes-button"
    >
      Yes
    </Button>
  </Modal.Footer>
</Modal>

      </div>
    </>
  );
}